const slugifyString = string => {
  return string?.split(' ').join('_');
};

export default slugifyString;
